<template>
<div id="itoolbar">

  <el-dialog title="工作统计" :visible.sync="dialogTableVisible" :modal-append-to-body="false" size='large'>
    <el-tabs v-model="activeName">
      <el-tab-pane label="工作数据" name="first">
        <!-- <span slot="label" ><i class="el-icon-time"></i>工作数据</span> -->
        <!-- <el-table
        v-loading="dialogTableLoading"
        element-loading-text="拼命加载中..."
        :data="newstats.process" show-summary
        style="width: 100%"
        height="250">
          <el-table-column fixed property="time" label="时间" width="100"></el-table-column>
          <el-table-column property="count" label="数量" width="447"></el-table-column>
        </el-table> -->

        <div id="salesTime" class="echarts-wrap"
          v-loading="dialogTableLoading"
          element-loading-text="拼命加载中..."></div>


      </el-tab-pane>
      <el-tab-pane label="驳回信息" name="second">
        <el-table
          v-loading="dialogTableLoading"
          element-loading-text="拼命加载中..."
          :data="newstats.fallback"
          style="width: 100%"
          height="250">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="标题">
                  <span>{{ props.row.title }}</span>
                </el-form-item>
                <el-form-item label="驳回原因">
                  <span>{{ props.row.tip }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            label="时间"
            prop="time"
            width="180">
          </el-table-column>
          <el-table-column
            label="标题"
            prop="title"
            min-width="250">
          </el-table-column>
          <el-table-column
            label="驳回原因"
            prop="tip"
            min-width="250">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>



    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogTableVisible = false; dialogTableLoading = false">取 消</el-button>
      <el-button type="primary" @click="dialogTableVisible = false; dialogTableLoading = false">确 定</el-button>
    </div>

  </el-dialog>

  <!--sm:768 md:1024, lg:1440-->
  <!-- <div class="toolbar-nav"> -->
  <el-row type="flex" justify="center" align="middle" class="toolbar-nav">
    <!-- <router-link :to="{ path: `/beltline/${type}/list`, query: { plan: 'private' }}">
      <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_editor_nav.png" v-if="type==='ieditor'">
      <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_record_nav.png" v-if="type==='irecord'">
      <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_check_nav.png" v-if="type==='audit'">
      <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_guest_nav.png" v-if="type==='press'">
      <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_monitor_nav.png" v-if="type==='stats'">
    </router-link> -->
    <el-col :xs="6" :sm="5" :md="5" :lg="3" class="toolbar-log-box">
      <a href="javascript:void(0)" @click="handlelogoclick(type)">
        <img class="toolbar-logo" src="../../static/img/banma.png"/>
        <!-- <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_record_nav1.png" v-if="type==='irecord'"/>
        <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_check_nav1.png" v-if="type==='audit'"/>
        <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_guest_nav1.png" v-if="type==='press'"/>
        <img class="toolbar-logo" src="../../static/img/ibroadcast/logo_monitor_nav1.png" v-if="type==='stats'"/> -->
      </a>
      <span class="fs-text" style="color:#E5E9F2;">&nbsp;·&nbsp;{{ComputerRouterName}}</span>
    </el-col>
    <!-- <el-menu theme="dark" :default-active="type" class="toolbar-menu" mode="horizontal" :router="true" @select="handleSelect">
      <template v-for="item in headernav">
		    <el-menu-item :index="item.url">{{ item.name }}</el-menu-item>
	     </template>
	  </el-menu> -->

    <el-col :xs="15" :sm="16" :md="14" :lg="10">
      <el-menu id="nav-specialControl" theme="dark" :default-active="activeIndex" :unique-opened="true" class="toolbar-menu" mode="horizontal" :router="true" @select="handleSelect">
        <template v-for="(item, index) in headernav">
          <template v-if="item.child">
            <el-submenu :index="item.type">
              <!-- <template slot="title">{{ item.name }}</template> -->
              <template slot="title">{{ readMenuItemName }}</template>
              <template v-for="childitem in item.child">
                  <el-menu-item :index="childitem.url" >{{ childitem.name }}</el-menu-item>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :index="item.type">{{ item.name }}</el-menu-item>
          </template>
        </template>
      </el-menu>
    </el-col>
    <!-- <span class="toolbar-menu-item" v-if="keypath === 'list'&&type==='ieditor'">{{readMenuItemName}}</span> -->
    <el-col :xs="3" :sm="3" :md="5" :lg="3">
  		<div class="toolbar-features">
      <!-- <el-tooltip class="item" effect="dark" :content="querytext" placement="left" :hide-after="1">
        <el-button class='feat-button' type="text" size='large' @click="handleQueryClick"><i class="el-icon-upload fs-title" v-if="(keypath === 'list'||keypath === 'review')&&type==='ieditor'"></i></el-button>
      </el-tooltip> -->
      <el-button class='feat-button' type="text" size='large' @click="handleAddClick"><i class="el-icon-plus fs-text" v-if="(keypath === 'list'||keypath === 'review')&&type==='ieditor'"></i></el-button>

  			<el-dropdown @command="handleCommand" trigger="click">
  				<div class="el-dropdown-link">
          <!-- <el-badge is-dot class="item" > -->
  					<i class="iconfont icon-user fs-text"></i>
          <!-- </el-badge> -->
            <span class="features-name fs-text">{{ account }}</span>
            <i class="iconfont icon-menu fs-text" v-show="type!=='press'&&type!=='stats'"></i>
  				</div>
  				<el-dropdown-menu slot="dropdown" class="fs-text">
  					<!-- <el-dropdown-item disabled>账号管理</el-dropdown-item> -->
            <span v-show="type!=='press'&&type!=='stats'">
              <el-dropdown-item command="workstats">工作统计</el-dropdown-item>
            </span>
  					<el-dropdown-item command="outLogin" :divided="type!=='press'&&type!=='stats'">退出登录</el-dropdown-item>
  				</el-dropdown-menu>
  			</el-dropdown>
  		</div>
    </el-col>
  </el-row>
	<!-- </div> -->


</div>
</template>

<script>
// 顶部导航栏
import '../../static/style/inavigation/headernav.scss'
import { routeMap } from '../../utils/com.js'
import { newsType, headerOption, roleTypeId, routerType } from '../../config/config'
import {mapGetters, mapActions} from 'vuex';

import echarts from 'echarts'


export default {
    props: ['type'],
    data() {
        return {
          activeIndex: '',
          page: 1,
          limit: 10,
          clientid: 1,
          dialogTableVisible: false,
          dialogTableLoading: true,
          activeName: "first",

          // echartsDisplay: true,
          setOption: headerOption,
          querytext: '点击获取一条新闻',
          newtext: '点击创建一条新闻',
          // {
          //     title : {
          //       text: '新闻产出分布',
          //       subtext: '',
          //       x: 'center',
          //       align: 'right'
          //     },
          //     toolbox: {
          //         show : true,
          //         feature : {
          //           dataZoom: {
          //               yAxisIndex: 'none'
          //           },
          //           dataView: {
          //               show: true,
          //               readOnly: false
          //           },
          //           magicType: {
          //               show: false,
          //               type: ["bar"]
          //           },
          //           restore: {
          //               show: false
          //           },
          //           saveAsImage: {
          //               show: true
          //           }
          //         }
          //     },
          //     legend: {
          //         data:['新闻数量'],
          //         x: 'left'
          //     },
          //     tooltip : {
          //         trigger: 'axis',
          //         axisPointer: {
          //             type: 'cross',
          //             animation: false,
          //             label: {
          //                 backgroundColor: '#505765'
          //             }
          //         }
          //     },
          //     dataZoom: {
          //         show: true,
          //         realtime: true,
          //         start : 8
          //     },
          //     grid: {
          //         y2: 80
          //     },
          //     xAxis : [
          //         {
          //           type : 'time',
          //           splitNumber:6
          //         }
          //     ],
          //     yAxis : [
          //         {
          //           name: '数量(条/每小时)',
          //           type : 'value'
          //         }
          //     ],
          //     series : [
          //         {
          //             name: '新闻条数',
          //             type: 'line',
          //             showAllSymbol: true,
          //             data: null,
          //         }
          //     ]

          // }


        }
    },
    created() {
        // 获取数据
        this.$store.dispatch('headernavSwitch', this.type)
        // console.info("headernav> path:%o, params:%o, query:%o", this.$store.state.route.path, this.$store.state.route.params, this.$store.state.route.query);
        let active = this.$store.state.route.path.split('/');
        this.activeIndex = active[active.length - 1] || 'list';
          // console.debug("created> active:%o, activeIndex:%o", active[active.length - 1], this.activeIndex);
    },
    computed: {
        ...mapGetters({
            // 映射 this.getToken 为 store.getters.getToken
            getAccount: 'getAccount',
            getToken: 'getToken',
            getRole: 'getRole',
            getAppid: 'getAppid',
            getAccesstoken: 'getAccesstoken',
            newstats: 'newstats',
            newstatstotal: 'newstatstotal',
        }),
        headernav() { return this.$store.getters.headernav },
        account() { return this.$store.getters.getAccount },
        keypath(){
          let patarry = this.$store.state.route.path.split('/');
          // console.debug("keypath> patarry:%o", patarry);
          return patarry[patarry.length - 1];
        },
        headurl(){

        },
        readMenuItemName(){
          // console.debug("readMenuItemName> newsType:%o", newsType[this.activeIndex]);
          return newsType[this.activeIndex] || '分类'
        },
        ComputerRouterName(){
          // console.debug("ComputerRouterName> %o", routerType[this.type] || '班玛资讯');
          return routerType[this.type] || '班玛资讯'
        }
    },
    methods: {
      ...mapActions({
        // 映射 this.getEditorData() 为 this.$store.dispatch('getEditorData')
        getEditorData: 'getEditorData',
        getPressData: 'getPressData',
        getNewsData: 'getNewsData',
        updateLoadingStatus: 'updateLoadingStatus',
        getNewStatis: 'getNewStatis',
        updateNewsContent: 'updateNewsContent',
        queryUnusedContent: 'queryUnusedContent',
      }),
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      handleAddClick(){
        let param = {}
        this.updateNewsContent(param)
        this.$router.push({ path: routeMap('/ieditor/edit')})
      },
      handleQueryClick() {
        let param = {}
        this.updateNewsContent(param)
        // this.queryUnusedContent()
        this.$router.push({ path: routeMap('/ieditor/query'), query: { id: -1 } })
      },
      handlelogoclick(type){
        // console.debug("handlelogoclick> type:%o", type);
        // window.location.pathname = routeMap(`/${type}/list`);

        if(type === 'press'){
          // let param = {
          //     appid: this.getAppid,
          //     accesstoken: this.getAccesstoken,
          //     clientid: this.clientid,
          //     category: '',
          //     page: this.page,
          //     limit: this.limit,
          // }
          // console.debug("handlelogoclick> param:%o", param);
          // this.getPressData(param).then(
          //   (resp) => {
          //     console.debug("handlelogoclick> getPressData> resp:%s", resp);
          //   },
          //   (err) => {
          //     console.error("handlelogoclick> getPressData> err:%s", err);
          //   }
          // );
          // window.location.pathname = routeMap(`/${type}/list`);
          // this.activeIndex = type;
          this.activeIndex = this.activeIndex || 'list';
          // console.debug("handlelogoclick> activeIndex:%o", this.activeIndex);
          this.$router.push({ path: routeMap(`/${type}/${this.activeIndex}`), query: { page: 1 } });

        }
        // else if(type === 'audit'){
        //   window.location.pathname = routeMap(`/${type}/list`);
        // }
        else{
          // let param = {
          //     token: this.getToken,
          //     name: this.getAccount,
          //     state: type === 'ieditor' ? 1 : 2
          // }
          // console.debug("handlelogoclick> param:%o", param);
          // this.getEditorData(param);
          this.$router.push({ path: routeMap(`/${type}/list`), query: { page: 1 } });
          // let param = {
          //     state: roleTypeId[type] || '',//type === 'ieditor' ? 1 : 2,
          //     category: this.$store.state.route.query.type || '',
          //     page: this.page,
          //     limit: this.limit,
          // }
          // console.debug("handlelogoclick> param:%o", param);
          // // this.getEditorData(param);
          // console.debug("handlelogoclick> getNewsData> param:%o", param);
          // this.updateLoadingStatus(true);
          // this.getNewsData(param).then(
          //   (resp) => {
          //     this.updateLoadingStatus(false);
          //     console.debug("handlelogoclick> getNewsData> resp:%o", resp);
          //   },
          //   (err) => {
          //     this.updateLoadingStatus(false);
          //     console.error("handlelogoclick> getNewsData> err:%o", err);
          //   }
          // );

          // this.activeIndex = '';
        }
      },
      GetRequest(url) {
        let theRequest = new Object();
        if (url.indexOf("?") != -1) {
          let str = url.substr(1).split('?');
          // console.debug("GetRequest> str:%o", str);
          let strs = str[str.length-1].split("&");
          // console.debug("GetRequest> strs:%o", strs);
          for(let i = 0; i < strs.length; i ++) {
             theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
          }
         }
         return theRequest;
      },
      handleSelect(key, keyPath) {
          this.activeIndex = key;
          // console.debug("handleSelect> key:%o, keyPath:%o, activeIndex:%o", key, keyPath, this.activeIndex);

        if(this.type === 'ieditor'){
          var request = new Object();
          request = this.GetRequest(key);
          let type = request['type'] || '';
          // console.debug("handleSelect> type:%o", type);

          let param = {
              state: 1,
              category: type,
              page: this.page,
              limit: this.limit,
          }
          // console.debug("handleSelect> getNewsData> param:%o", param);
          // this.getEditorData(param);
          //
          // this.bodyloading = true;
          this.updateLoadingStatus(true);
          this.getNewsData(param).then(
            (resp) => {
              // this.bodyloading = false;
              this.updateLoadingStatus(false);
              // console.debug("handleSelect> getNewsData> resp:%o", resp);
            },
            (err) => {
              // this.bodyloading = false;
              this.updateLoadingStatus(false);
              console.error("handleSelect> getNewsData> err:%o", err);
            }
          );
        }
      },
      genData() {
        var d = [];
        var len = 0;
        // var now = new Date();
        var value;
        while (len++ < 50) {
            d.push([
                new Date(2014, 9, 1, 0, len * 10000),
                (Math.random()*30).toFixed(2) - 0
            ]);
        }
        // console.debug("genData> d:%o", d);
        return d;
      },
      showDiag() {
        var that = this;
        that.activeName = 'first';
        that.dialogTableVisible = true;
        let param = {};
        // console.debug("created> getNewStatis> param:%o", param);

        that.dialogTableLoading = true;
        that.getNewStatis(param).then(
          (resp) => {
            // this.updateLoadingStatus(false);
            that.dialogTableLoading = false;
            // console.debug("created> getNewStatis> resp:%o", resp);
            if(resp && resp.code !== 0){
              // that.echartsDisplay = false
              that.$message({
                    message: resp.msg,
                    type: 'error'
                });
            }else{

              let _data = resp.data.process, _legendData = []
              for (let item of _data) {
                let serialData = []
                // console.debug("getNewStatis> item:%o", item);
                let tarr = item.time.split(":");
                let pt = new Date().setHours(tarr[0], tarr[1])
                // console.debug("getNewStatis> tarr:%o, pt:%o", tarr, pt);
                serialData.push(pt);
                serialData.push(item.count)
                // console.debug("getNewStatis> _legendData:%o, serialData:%o", _legendData, serialData);
                _legendData.push(serialData)
              }
              // console.debug("showDiag> before sort> _legendData:%o", _legendData);
              // quick sort array
              for (let i = 1; i < _legendData.length; i++) {
                  let key = _legendData[i];
                  let j = i - 1;
                  while (j >= 0 && _legendData[j][0] > key[0]) {
                      _legendData[j + 1] = _legendData[j];
                      j--;
                  }
                  _legendData[j + 1] = key;
              }
              // console.debug("showDiag> after sort> _legendData:%o", _legendData);

              // console.debug("getNewStatis> _legendData:%o", _legendData);
              // that.setOption.legend.data = _legendData
              // that.setOption.series = _data
              that.setOption.series[0].data = _legendData //this.genData()
              that.setOption.dataZoom.start = resp.data.total < 3 ? 0 : 16
              if(resp.data.total !== 0){
                that.setOption.title.text = '新闻产出分布'
                that.setOption.title.subtext = '总数:'+resp.data.total
              }else{
                that.setOption.title.text = '暂无数据'
                that.setOption.title.subtext = ''
              }

              let myChart = echarts.init(document.getElementById('salesTime'))
              // console.debug("getNewStatis> setOption:%o", that.setOption);
              myChart.setOption(that.setOption)
            }
          }
        );

      },
  		handleCommand(command) {
  			// console.log(command);
  			switch(command){
          case 'workstats':
            this.showDiag();
            break;
  				case 'outLogin':
  					// 退出登录
  					this.$store.dispatch('outLogin')
            this.$router.push({ path: routeMap('/login'), query: { type: this.type }})
  					break;
  			}
  		}
    }
}
</script>



// WEBPACK FOOTER //
// headernav.vue?dacd6302